import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.addUserRelationDialog ? _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.closeAddUserRelationDialog();
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.save'),
            "prepend-icon": "fa-plus",
            "disabled": !_vm.formIsValid
          },
          on: {
            "click": _vm.handleSubmit
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.userRelationsDialogSave')) + "\n      ")])];
      },
      proxy: true
    }], null, false, 315572137)
  }, [_c(VForm, {
    ref: "userRelationsForm",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c(VAutocomplete, {
    staticClass: "mt-2",
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.userRelationsTableName'),
      "items": _vm.twinDataUsers,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-no-data": "",
      "search-input": _vm.search
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "blur": _vm.validateForm,
      "change": _vm.validateForm
    },
    model: {
      value: _vm.inputUserId,
      callback: function ($$v) {
        _vm.inputUserId = $$v;
      },
      expression: "inputUserId"
    }
  }), _c(VSelect, {
    attrs: {
      "items": _vm.selectRoleItems,
      "item-text": "role",
      "item-value": "roleId",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.userRelationsTableRole'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "change": _vm.validateForm
    },
    model: {
      value: _vm.inputRoleId,
      callback: function ($$v) {
        _vm.inputRoleId = $$v;
      },
      expression: "inputRoleId"
    }
  })], 1)], 1) : _vm._e(), _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "offset": "20",
      "buttons": _vm.buttons
    },
    on: {
      "addItem": _vm.openAddUserRelationDialog
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.userRelationsTableHeadline')))])]), _c(VDataTable, {
    attrs: {
      "disable-sort": "",
      "headers": _vm.headers,
      "items": _vm.userRelations,
      "footer-props": _vm.tableFooterProps,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(items.item.name))]), _c('td', [_vm._v(_vm._s(items.item.role))]), _c('td', {
          staticClass: "text-right",
          staticStyle: {
            "width": "40px"
          }
        }, [_c(VIcon, {
          attrs: {
            "disabled": _vm.disabled,
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.updateUserRelation(items.item.userId, items.item.roleId);
            }
          }
        }, [_vm._v("\n              fal fa-edit\n            ")])], 1), _c('td', {
          staticClass: "text-right",
          staticStyle: {
            "width": "40px"
          }
        }, [_c(VIcon, {
          attrs: {
            "disabled": _vm.disabled,
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.deleteUserRelation(items.item.userId, items.item.roleId);
            }
          }
        }, [_vm._v("\n              fal fa-trash-alt\n            ")])], 1)])];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n        ")])];
      },
      proxy: true
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };